import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import { Handover } from '../components/Handover'
import { LogoWall } from '../components/LogoWall'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Studio A45 geht in neue Hände"
      description="Wir haben Studio A45 an die digicube AG aus Schaan übergeben und fokussieren uns künftig ganz auf Rezendo. Danke für 8 gemeinsame Jahre."
      keywords={[`Studio A45`, `digicube`, `Rezendo`, `Übergabe`, `Liechtenstein`]}
    />
    <Handover />
    <LogoWall />
  </Layout>
)

export default IndexPage
